<template>
  <div class="activity-list-page">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad">
      <van-cell v-for="(item, index) in activities" :key="index">
        <router-link :to="{name: 'activity.detail', query: {id: item.id}}" class="item">
          <div class="status">
            <van-tag type="primary" v-if="item.end_at > now" name="进行中">进行中</van-tag>
            <van-tag v-else name="已结束">已结束</van-tag>
          </div>
          <div class="left">
            <div>
              {{item.title}}
            </div>
            <div class="cost">
              {{item.start_at | toLocaleDateString}} 至 {{item.end_at | toLocaleDateString}}
              </div>
          </div>
          <div class="right">
            <div class="">奖金池</div>
            <div class="money">{{item.money_award}}元</div>
          </div>
        </router-link>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
import {
  Tag,
  List,
  Cell,
} from 'vant';
import ActivityProxy from '@/proxies/activity';

export default {
  data() {
    return {
      activities: [],
      finished: false,
      loading: false,
      pageIndex: 1,
      now: new Date().getTime(),
    };
  },
  components: {
    [Tag.name]: Tag,
    [List.name]: List,
    [Cell.name]: Cell,
  },
  methods: {
    onLoad() {
      this.loading = true;
      setTimeout(() => {
        this.getActivityList();
      }, 500);
    },
    async getActivityList() {
      const params = {
        page: this.pageIndex,
      };
      const res = await ActivityProxy.getActivityList(params);
      this.loading = false;
      if (!res.fail) {
        // 如果是获取第一页就清空整个列表TODO
        if (this.pageIndex === 1) {
          this.activities = [];
        }
        this.pageIndex += 1;
        this.activities = this.activities.concat(res.data.list);
        this.totalRecordCount = res.data.totalCount;
        // 无数据
        if (this.activities.length === this.totalRecordCount || !res.data.list.length) {
          this.finished = true;
        } else if (this.activities.length < this.totalRecordCount) {
        // 还有数据
          this.finished = false;
        }
      }
    },
  },
};
</script>
<style lang="less">
.activity-list-page {
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    overflow: hidden;
    position: relative;
  }
  .status {
    flex-shrink: 0;
  }
  .left {
    flex-grow: 1;
    margin-left: 20px;
  }
  .right {
    font-size: 12px;
    flex-shrink: 0;
    color: #666;
    text-align: right;
  }
  .cost {
    font-size: 12px;
    color: #666;
  }
  .money {
    color: #F56C6C;
    font-size: 16px;
  }
  .time {
    font-size: 16px;
    color: #bbb;
  }
}
</style>
